function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "387px",
    height: "387px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3eee6",
    d: "M 386.5,191.5 C 386.5,192.5 386.5,193.5 386.5,194.5C 383.283,263.782 352.95,317.615 295.5,356C 241.081,388.025 184.081,393.359 124.5,372C 75.6823,352.183 40.1823,318.35 18,270.5C -6.81292,210.547 -3.47958,152.213 28,95.5C 66.2088,34.7979 121.376,3.13125 193.5,0.5C 274.227,4.12716 332.727,41.7938 369,113.5C 379.92,138.5 385.753,164.5 386.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#56cdb8",
    d: "M 128.5,131.5 C 172.168,131.333 215.835,131.5 259.5,132C 264.598,133.433 268.098,136.6 270,141.5C 270.667,175.5 270.667,209.5 270,243.5C 267.744,248.757 263.91,252.257 258.5,254C 215.167,254.667 171.833,254.667 128.5,254C 123.056,252.376 119.556,248.876 118,243.5C 117.333,209.5 117.333,175.5 118,141.5C 120.106,136.557 123.606,133.224 128.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c0ede4",
    d: "M 144.5,147.5 C 177.331,146.336 210.331,146.169 243.5,147C 227,161.5 210.5,176 194,190.5C 177.628,175.957 161.128,161.624 144.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2ede5",
    d: "M 253.5,158.5 C 254.498,184.995 254.831,211.661 254.5,238.5C 213.833,238.5 173.167,238.5 132.5,238.5C 132.333,211.498 132.5,184.498 133,157.5C 150.167,172.667 167.333,187.833 184.5,203C 187.188,205.694 190.355,207.527 194,208.5C 195.627,208.375 197.127,207.875 198.5,207C 216.73,190.596 235.063,174.429 253.5,158.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6e4d9",
    d: "M 253.5,158.5 C 253.56,157.957 253.893,157.624 254.5,157.5C 255.829,184.664 255.829,211.664 254.5,238.5C 254.831,211.661 254.498,184.995 253.5,158.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.560c63f56215633a66230a264dc0c84d.svg";
export { ForwardRef as ReactComponent };